import * as CM                       from '@emersya/mpa-components-manager';
import { InputNumberComponent } from '../InputNumber';

export class TextualWithIncrementRenderingMode extends CM.Plugin<
	InputNumberComponent
>
{
	id = 'textualWithIncrement';

	attach(component : InputNumberComponent) {
		void component;
	};

	detach(component : InputNumberComponent) {
		void component;
	};

	async boundsUpdated(component : InputNumberComponent, stepsCountDiff : number) {
		void component;
		void stepsCountDiff;
		await <Promise<void>> <any> void 1;
	};
};
